<template>
    <AdminLayout>
        <div class="table-container px-4">
            <div class="rows-header">
                <div class="d-flex justify-content-end">
                    <PaginationComp :current-page="response.currentPage" :total-pages="response.totalPages"
                        :total-rows="response.totalRows" :rows-per-page="response.rowsPerPage"
                        :has-previous="response.hasPrevious" :has-next="response.hasNext" :max-visible-pages="5"
                        :show-info="true" :show-page-numbers="true" :show-rows-per-page="true" :show-go-to-page="true"
                        :rows-per-page-options="[10, 25, 50, 100, 250, 500]" @page-changed="handlePageChange"
                        @rows-per-page-changed="handleRowsPerPageChange" />
                </div>
            </div>

            <form @submit.prevent="handleSubmit" class="h-100">
                <div class="table-section">
                    <table class="table table-hover table-sm align-middle">
                        <thead style="position: sticky; top: 0; z-index: 10;">
                            <tr>
                                <th>User</th>
                                <th>Received By</th>
                                <th>Status</th>
                                <th>Amount</th>
                                <th>Created</th>
                                <th>Accepted</th>
                            </tr>
                            <tr>
                                <th>
                                    <input class="form-control" v-model="searchModel.remittedBy" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.receivedBy" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.status_rmt" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.amount_rmt" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.dateadded_rmt" />
                                </th>
                                <th>
                                    <input class="form-control" v-model="searchModel.dateaccepted_rmt" />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="isSearching">
                                <TableSkeleton :columns="12" />
                            </template>
                            <template v-else-if="response?.remittances?.length === 0">
                                <EmptyTable :colspan="12" />
                            </template>
                            <template v-else>
                                <tr v-for="remittance in response.remittances" :key="remittance.syspk_rmt">
                                    <td>{{ remittance.remittedBy }}</td>
                                    <td>{{ remittance.receivedBy }}</td>
                                    <td>{{ remittance.status_rmt }}</td>
                                    <td class="text-end">{{ Formatters.formatCurrency(remittance.amount_rmt) }}</td>
                                    <td>{{ remittance.dateadded_rmt }}</td>
                                    <td>{{ remittance.dateaccepted_rmt }}</td>
                                    <td>
                                        <div class="btn-group">
                                            <button v-if="remittance.status_rmt === 'PENDING'" type="button" class="btn btn-xs btn-success" @click="acceptRemittance(remittance)">Accept</button>
                                            <button v-if="remittance.status_rmt === 'PENDING' && hasRoles(['can-delete'])" type="button" class="btn btn-xs btn-danger" @click="deleteRemittance(remittance)">Delete</button>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <button type="submit" class="d-none">Submit</button>
            </form>
        </div>


    </AdminLayout>
</template>

<script setup>

import EmptyTable from '@/components/animations/EmptyTable.vue';
import TableSkeleton from '@/components/animations/TableSkeleton.vue';
import PaginationComp from '@/components/commons/PaginationComp.vue';
import AdminLayout from '@/layouts/AdminLayout.vue';
import confirmationService from '@/services/confirmationService';
import toastService from '@/services/toastService';
import transactionService from '@/services/transactionService';
import { hasRoles } from '@/utils/auth';
import Formatters from '@/utils/formatters';
import { onMounted, ref } from 'vue';
const searchModel = ref({});
const isSearching = ref(false);
const response = ref({
    remittances: [], // This will vary
    currentPage: 1,
    totalPages: 0,
    totalRows: 0,
    rowsPerPage: 100,
    hasPrevious: false,
    hasNext: false
});

const handlePageChange = (page) => {
    response.value.currentPage = page;
    search();
}

const handleRowsPerPageChange = (rowsPerPage) => {
    response.value.currentPage = 1;
    response.value.rowsPerPage = rowsPerPage;
    search();
}

const acceptRemittance = async(remittance)=>{
    const confirmed = await confirmationService.show("Are you sure you want to receive this remittance?");
    if(!confirmed)return;
    const resp = await transactionService.acceptRemittance({remittanceId: remittance.syspk_rmt, amount: remittance.amount_rmt,userId: remittance.sysfk_user_rmt});
    if(resp.code > -1){
        toastService.success("Remittance Accepted!");
        search();
    }
    else{
        toastService.error(resp.message);
    }
}
const deleteRemittance = async(remittance)=>{
    const confirmed = await confirmationService.show("Are you sure you want to delete this remittance?");
    if(!confirmed)return;
    const resp = await transactionService.deleteRemittance(remittance.syspk_rmt);
    if(resp.code > -1){
        toastService.success("Remittance deleted!");
        search();
    }
    else{
        toastService.error(resp.message);
    }
}



const handleSubmit = () => {
    response.value.currentPage = 1;
    search();
}

const search = async () => {
    isSearching.value = true;
    response.value = await transactionService.searchRemittances(response.value.currentPage, response.value.rowsPerPage, searchModel.value);
    isSearching.value = false;
}

onMounted(() => {
    search();
});

</script>

<style scoped>
.table-section {
    background: white;
    border-radius: 16px;
    overflow: auto;
    box-shadow: 0 5px 25px rgba(220, 53, 69, 0.08);
    border: 1px solid rgba(220, 53, 69, 0.05);
    max-height: 85vh;
}


/* Container for the entire section */
.table-container {
    position: relative;
    height: 100vh;
    /* or whatever height you want */
    display: flex;
    flex-direction: column;
}

/* Freeze the Rows div */
.rows-header {
    position: sticky;
    top: 0;
    background: white;
    /* or your background color */
    z-index: 100;
    padding: 10px 0;
    border-bottom: 1px solid #dee2e6;
}

/* Make the table responsive container scrollable */
.table-responsive {
    flex: 1;
    overflow-y: auto;
    overflow-x: auto;
    position: relative;
}

/* Freeze the thead */
.table thead {
    position: sticky;
    top: 0;
    z-index: 50;
    background: white;
    /* or your background color */
}

.table thead th {
    background: white;
    /* or your background color */
    border-bottom: 2px solid #dee2e6;
}

/* If you want both rows of thead to stay */
.table thead tr {
    background: white;
    /* or your background color */
}

/* For the second thead row (filter inputs) */
.table thead tr:last-child th {
    background: white;
    /* or your background color */
    border-bottom: 1px solid #dee2e6;
}
</style>